module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('router-link', {
      staticClass: "no-redirect",
      attrs: {
        "to": ""
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e2bbcf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Levelbar.vue
// module id = 274
// module chunks = 30